module.exports = __webpack_public_path__ + "img/2.a25ae90d.jpg";